(function () {
    'use strict';

    function linkResourcesGroupConfigurationContent() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/linkResourcesGroupConfigurationContent.html',
            link: function (scope) {
            }
        };
    }

    linkResourcesGroupConfigurationContent.$inject = [];

    angular.module('ecap.siteConfiguration').directive('linkResourcesGroupConfigurationContent', linkResourcesGroupConfigurationContent);
})();

